import { FC } from 'react'
import { PaymentMethods } from './components/PaymentMethods/PaymentMethods'
import { FooterColumn } from './components/FooterColumn/FooterColumn'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Text } from '@blueprintjs/core'
import { Link } from '@inertiajs/react'
import { CartDrawer } from 'client/components/CartDrawer/CartDrawer'

type TProps = {}

const Footer: FC<TProps> = ({}) => {
  const { t } = useTranslation(ClientLocaleNS.Common)
  return (
    <footer className="flex flex-col justify-center w-full gap-20 pb-20">
      <ResponsiveBlock className="pt-12">
        <PaymentMethods />
      </ResponsiveBlock>
      <ResponsiveBlock>
        <div className="grid grid-cols-3 w-full gap-20">
          <FooterColumn i18key="footer.titles.1">
            <Text tagName="span" className="text-palette-grey--50 font-body---16px whitespace-pre-wrap leading-6">
              {t('footer.address')}
            </Text>
            <Text tagName="span" className="text-palette-grey--50 font-body---16px whitespace-pre-wrap leading-6">
              {t('footer.registration')}
            </Text>
          </FooterColumn>
          <FooterColumn i18key="footer.titles.2" className="justify-center">
            <Link href="/refundpolicy">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.payment')}
              </Text>
            </Link>
            <Link href="/policy">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.privacy')}
              </Text>
            </Link>
            <Link href="/policydda">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.policydda')}
              </Text>
            </Link>
            {/* <Link href="/public_offer">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.public_offer')}
              </Text>
            </Link> */}
          </FooterColumn>
          <FooterColumn i18key="footer.titles.3" className="justify-end">
            <div className="flex flex-col">
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                {t('footer.support_email')}
              </Text>
              <Text tagName="span" className="text-palette-grey--50 font-body---20px whitespace-pre-wrap">
                24/7
              </Text>
            </div>
          </FooterColumn>
        </div>
      </ResponsiveBlock>
      <CartDrawer />
    </footer>
  )
}

export { Footer }
